import { TableColumnDefinition } from '@antimatterhq/ui/types/TableColumnDefinition';

export const transformTableColumnDefinitions: TableColumnDefinition[] = [
  {
    id: 'name',
    title: 'Transform name',
    width: 200,
  },
  {
    id: 'comment',
    title: 'Transform comment',
    width: 300,
  },
  {
    id: 'lastModified',
    title: 'Last modified',
    width: 200,
  },
  {
    id: 'annotations',
    title: 'Annotations',
    hidden: true,
  },
  {
    id: 'inputTables',
    title: 'Input tables',
    hidden: true,
  },
  {
    id: 'schedule',
    title: 'Schedule',
    hidden: true,
  },
  {
    id: 'edit',
    tooltip: false,
    title: '',
    width: 40,
    enableResize: false,
    enableFiltering: false,
    enableSorting: false,
    pinned: 'right',
  },
];
